export default __webpack_public_path__ + "static/media/component_servo_motor.2b49a239.png";